import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { ArrowUpRight, Phone, Send } from 'lucide-react';

export default function CTASection() {
  return (
    <section id="catering" className="max-w-7xl mx-auto px-4 sm:px-6 pb-20">
      <div className="relative overflow-hidden rounded-[32px] bg-[#245A40] text-[#F6F2E8] p-10 sm:p-16 lg:p-20">
        <div className="absolute -right-24 -top-24 w-96 h-96 rounded-full bg-white/10" />
        <div className="absolute -right-8 -bottom-16 w-64 h-64 rounded-full bg-[#E8C56B]/30" />
        <div className="relative max-w-2xl">
          <div className="text-xs uppercase tracking-[0.22em] font-semibold text-[#E8C56B]">Catering for teams</div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl mt-4 leading-[1.05]">
            Feed your team something <em className="italic">they’ll thank you for.</em>
          </h2>
          <p className="mt-5 text-white/90 text-lg">
            Daily, weekly or monthly corporate lunch catering for offices across Chicago. 24-hour notice, $300 minimum, free delivery and setup included.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <Button asChild className="bg-[#F6F2E8] hover:bg-white text-[#1B2A22] rounded-full h-12 px-7 font-semibold text-base">
              <a href="#menu">Browse the menu <ArrowUpRight className="w-4 h-4 ml-1" /></a>
            </Button>
            <Button asChild className="bg-[#245A40] hover:bg-[#1B4631] text-[#F6F2E8] rounded-full h-12 px-7 font-semibold text-base">
              <Link to="/catering-inquiry"><Send className="w-4 h-4 mr-1.5" /> Send catering inquiry</Link>
            </Button>
            <Button asChild variant="ghost" className="rounded-full h-12 px-7 font-semibold text-base border border-white/40 text-[#F6F2E8] hover:bg-white/10">
              <a href="tel:7738570230"><Phone className="w-4 h-4 mr-1.5" /> 773-857-0230</a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
